import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IWildlifeManagementFifthSection = {
    AdditionalDocuments?: Array<IFormFilesInterface>,
}

export const WildlifeManagementFifthSectionInterface = (): IWildlifeManagementFifthSection => ({
    AdditionalDocuments: undefined
})